import { useMemo } from 'react';

import { type FilterConfig } from '@/productDiscovery/Listings/interfaces/filterConfig';

export const useDeliveryFilterConfigs = (
  filtersConfig: FilterConfig[],
): FilterConfig[] =>
  useMemo(
    () =>
      filtersConfig.filter((filter) =>
        ['has_relay_delivery', 'has_free_delivery', 'is_mmf'].includes(
          filter.attributeName,
        ),
      ),
    [filtersConfig],
  );
